var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_186_2327)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11.6278V20.6879C8 21.1808 8.36077 21.5803 8.85781 21.5803H22.9977C23.4942 21.5803 23.8555 21.1762 23.8555 20.6879V11.6278C23.8555 11.0869 23.5324 10.6667 22.9977 10.6667H8.85781C8.30245 10.6667 8 11.0972 8 11.6278ZM9.30374 12.4169C9.30374 12.1986 9.43587 12.0737 9.64697 12.0737C9.77755 12.0737 14.9156 15.3295 15.2268 15.5204L16.031 16.0206C16.2859 15.8497 16.5419 15.7037 16.8062 15.5266C17.3455 15.1818 22.1445 12.0737 22.2766 12.0737C22.4883 12.0737 22.6199 12.1986 22.6199 12.4169C22.6199 12.6482 22.1745 12.8778 21.8844 13.0549C20.0619 14.1656 18.24 15.3764 16.4356 16.5284C16.3303 16.5997 16.1265 16.7519 15.9737 16.7287C15.8034 16.7024 10.575 13.3434 9.62374 12.7839C9.48077 12.6998 9.30374 12.6229 9.30374 12.4169Z",
    fill: "#083844"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_2327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b1f06125bf2dde247d2a19c63c26e3ad.svg";
export { ForwardRef as ReactComponent };